import { render, staticRenderFns } from "./Dialog_UpdatePowerTemplate.vue?vue&type=template&id=61128022&scoped=true&"
import script from "./Dialog_UpdatePowerTemplate.vue?vue&type=script&lang=js&"
export * from "./Dialog_UpdatePowerTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61128022",
  null
  
)

export default component.exports